import React, { useState } from 'react';
import { ApplyCuponProps } from '../types/components';
import { TextInput, DropdownInput } from '../../../components/inputs';

const ApplyCoupon = ({
    loadingValidation,
    validateCoupon,
    removeAllCoupons,
    applyManualDiscount,
    info,
}: ApplyCuponProps) => {
    const [couponCode, setCouponCode] = useState('');
    const [activeTab, setActiveTab] = useState<'coupon' | 'manual'>('coupon');
    const [manualDiscount, setManualDiscount] = useState({
        value: '',
        type: true,
    });

    const discountTypeOptions = [
        { label: 'Porcentaje (%)', value: true },
        { label: 'Monto fijo (S/)', value: false }
    ];

    const handleValidateCoupon  = async () => {
        const couponValidate = await validateCoupon(couponCode);
        if (couponValidate) {
            setCouponCode('');
        }
    }

    const handleApplyManualDiscount = () => {
        const couponValidate = applyManualDiscount(manualDiscount);
        if (couponValidate !== false){
            setManualDiscount({
                ...manualDiscount,
                value: '',
            })
        }
    }

    return (
        <div className="form-group mt-3">
            <h5 className="mb-2">Descuentos</h5>

            <div className="mb-3">
                <div className="btn-group w-100">
                    <button
                        className={`btn ${activeTab === 'coupon' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => setActiveTab('coupon')}
                    >
                        Cupón
                    </button>
                    <button
                        className={`btn ${activeTab === 'manual' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => setActiveTab('manual')}
                    >
                        Descuento Manual
                    </button>
                </div>
            </div>

            {activeTab === 'coupon' ? (
                <>
                    <div className="input-group mb-2">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Código de Cupón"
                            value={couponCode}
                            onChange={(e) => setCouponCode(e.target.value)}
                        />
                        <button
                            className="btn btn-primary"
                            onClick={handleValidateCoupon}
                            disabled={loadingValidation}
                        >
                            {loadingValidation ? <i className="fa fa-spinner fa-spin"></i> : 'Aplicar'}
                        </button>
                    </div>
                    <div className="mb-3">
                        <button className="btn btn-danger" onClick={removeAllCoupons}>
                            Eliminar Cupón
                        </button>
                    </div>
                </>
            ) : (
                <>
                    <div className="row">
                        <div className="col-md-6">
                            <TextInput
                                label="Valor del descuento"
                                value={manualDiscount.value}
                                onChange={(e) => setManualDiscount({...manualDiscount, value: e.target.value})}
                                placeholder="Valor del descuento"
                            />
                        </div>
                        <div className="col-md-6">
                            <DropdownInput
                                label="Tipo de descuento"
                                value={manualDiscount.type}
                                placeholder="Tipo de descuento"
                                onChange={(e) => setManualDiscount({...manualDiscount, type: e.target.value})}
                                options={discountTypeOptions}
                            />
                        </div>
                    </div>
                    <div className="mb-3">
                        <button
                            className="btn btn-primary me-2"
                            onClick={handleApplyManualDiscount}
                        >
                            Aplicar Descuento
                        </button>
                        <button
                            className="btn btn-danger"
                            onClick={removeAllCoupons}
                        >
                            Eliminar Descuento
                        </button>
                    </div>
                </>
            )}

            {info.length > 0 && (
                <div className={`alert ${info[0].field === 'success' ? 'alert-success' : 'alert-danger'} mt-3`}>
                    {info[0].message}
                </div>
            )}
        </div>
    );
};

export default ApplyCoupon;